/**
 * Cooperativa e SUBTIPO de pessoa juridica, nao uma terceira natureza.
 *
 * A coluna `credenciados.tipo` guarda `PF`, `PJ` ou `COOPERATIVA`, e a diferenca
 * entre os dois ultimos importa em pouca coisa — regra de rateio entre cooperados,
 * basicamente. Em tudo o mais (documento, nota, retencao) cooperativa e PJ.
 *
 * Sem este arquivo, cada tela decide sozinha se cooperativa "conta como PJ", e
 * inevitavelmente um relatorio soma 100 PJ enquanto outro soma 130 — a diferenca
 * sendo as cooperativas que uma contou e a outra nao.
 */

export type TipoDeCredenciado = 'PF' | 'PJ' | 'COOPERATIVA';
export type NaturezaDaPessoa = 'PF' | 'PJ';

/** Natureza legal: `PF` para PF, `PJ` para PJ e para cooperativa. */
export function naturezaDaPessoa(
  tipo: TipoDeCredenciado | string | null | undefined,
): NaturezaDaPessoa | null {
  if (!tipo) {
    return null;
  }
  if (tipo === 'PF') {
    return 'PF';
  }
  if (tipo === 'PJ' || tipo === 'COOPERATIVA') {
    return 'PJ';
  }
  return null;
}

/** Tratado como pessoa juridica — inclui cooperativa. */
export function ehPessoaJuridica(tipo: TipoDeCredenciado | string | null | undefined): boolean {
  return naturezaDaPessoa(tipo) === 'PJ';
}

/** Cooperativa propriamente dita. */
export function ehCooperativa(tipo: TipoDeCredenciado | string | null | undefined): boolean {
  return tipo === 'COOPERATIVA';
}

/** Como o tipo aparece na tela, preservando a distincao da cooperativa. */
export function rotuloDoTipoDeCredenciado(
  tipo: TipoDeCredenciado | string | null | undefined,
): string {
  if (tipo === 'PF') {
    return 'Pessoa física';
  }
  if (tipo === 'PJ') {
    return 'Pessoa jurídica';
  }
  if (tipo === 'COOPERATIVA') {
    return 'Cooperativa';
  }
  return '—';
}
